export interface PlanVariant {
  id: string;          // e.g., 'individual_monthly', 'school_monthly_tier2'
  price: number;       // For UI display fallback if firestore fails
  currency: string;    // e.g., 'KSH'
}

export interface SubscriptionTier {
  id: string;
  name: string;
  description: string;
  isAvailable: boolean; // Toggle for 'Coming Soon'
  features: string[];
  variants: {
    individual: {
      monthly: PlanVariant;
      termly: PlanVariant;
      yearly: PlanVariant;
    };
    faculty: {
      monthly: PlanVariant;
      termly: PlanVariant;
      yearly: PlanVariant;
    };
  };
}

export const SUBSCRIPTION_TIERS: Record<string, SubscriptionTier> = {
  tier1: {
    id: 'tier1',
    name: 'Tier 1 (Standard)',
    description: 'Standard features: lesson planning, resource library, AI research, assessments, and utilities.',
    isAvailable: true,
    features: ['AI Lesson Planning', 'Resource Library', 'AI Research Lab', 'Manual & AI Assessments', 'PDF Converter & Utilities'],
    variants: {
      individual: {
        monthly: { id: 'individual_monthly', price: 1500, currency: 'KSH' },
        termly: { id: 'individual_termly', price: 4000, currency: 'KSH' },
        yearly: { id: 'individual_yearly', price: 12000, currency: 'KSH' }
      },
      faculty: {
        monthly: { id: 'school_monthly', price: 20000, currency: 'KSH' },
        termly: { id: 'school_termly', price: 55000, currency: 'KSH' },
        yearly: { id: 'school_yearly', price: 180000, currency: 'KSH' }
      }
    }
  },
  tier2: {
    id: 'tier2',
    name: 'Tier 2 (Premium)',
    description: 'Premium features including AI-driven analytics and advanced reporting. (Coming soon)',
    isAvailable: false,
    features: ['All Standard Features', 'AI-driven Analytics', 'Advanced Reporting', 'Priority Support'],
    variants: {
      individual: {
        monthly: { id: 'individual_monthly_tier2', price: 2500, currency: 'KSH' },
        termly: { id: 'individual_termly_tier2', price: 7000, currency: 'KSH' },
        yearly: { id: 'individual_yearly_tier2', price: 20000, currency: 'KSH' }
      },
      faculty: {
        monthly: { id: 'school_monthly_tier2', price: 30000, currency: 'KSH' },
        termly: { id: 'school_termly_tier2', price: 85000, currency: 'KSH' },
        yearly: { id: 'school_yearly_tier2', price: 280000, currency: 'KSH' }
      }
    }
  }
};
